// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__TcXkW","icon":"SortAdornment_icon__9S2GL","up":"SortAdornment_up__Z8So9","down":"SortAdornment_down__3wIJG","active":"SortAdornment_active__hYYt2"};